import { FC } from 'react'
import { User } from '@wellesley/openapi'
import useFollow from 'hooks/useFollow'
import FollowButton, { FollowButtonProps } from './FollowButton'
import { useIsOwnProfile } from '@wellesley/user'
import { cn } from '@wellesley/ui'
import useActionGuard from 'hooks/useActionGuard'

export type FollowControlProps = Pick<
  FollowButtonProps,
  | 'size'
  | 'className'
  | 'relationship'
  | 'isRelationshipPending'
  | 'followButtonText'
  | 'unfollowButtonText'
> & {
  user: User
  disabled?: boolean
  onFollow?(): void
  onUnfollow?(): void
}

const FollowControl: FC<FollowControlProps> = ({
  user,
  size = 'm',
  disabled,
  className,
  relationship,
  isRelationshipPending,
  onFollow,
  onUnfollow,
  followButtonText,
  unfollowButtonText,
}) => {
  const { follow, unfollow, renderGuestFollowModal } = useFollow({
    user,
    onFollow,
    onUnfollow,
  })

  const isOwnProfile = useIsOwnProfile(user.id)

  const { isDisabled, ActionTooltipWrapper } = useActionGuard()

  if (isOwnProfile || isRelationshipPending) return null

  return (
    <div data-testid="followControl">
      {renderGuestFollowModal()}
      <ActionTooltipWrapper triggerClassname={cn(size === 'l' && 'w-full')}>
        <FollowButton
          {...{ user, size, disabled, className }}
          follow={() => void follow()}
          unfollow={() => void unfollow()}
          disabled={isDisabled}
          relationship={relationship}
          isRelationshipPending={false}
          followButtonText={followButtonText}
          unfollowButtonText={unfollowButtonText}
        />
      </ActionTooltipWrapper>
    </div>
  )
}

export default FollowControl
